import { ErrorMessage } from '@hookform/error-message'
import { browserLocalPersistence, setPersistence, signInWithEmailAndPassword } from 'firebase/auth'
import { FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { postSignupData } from '../../../api/mi'
import { auth } from '../../../firebase'
import { SignupMiUser } from '../../../models/miModel'
import { LoginPath, SendEmailPath } from '../../../routes/path'
import { requestState } from '../../../states/atoms'
import { StyleFormHead } from '../../../styles/mi'
import { Button } from '../../Button'
import { HelperText } from '../../HelperText'
import { Input } from '../Input'

export const SignupSection: FC = () => {
  const query = new URLSearchParams(useLocation().search)
  const key = query.get('key') || ''
  const email = query.get('email') || ''
  const setRequestState = useSetRecoilState(requestState)

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<SignupMiUser>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      key: key,
      email: decodeURIComponent(email),
      password: '',
      passwordConfirmation: '',
      firstName: '',
      lastName: '',
    },
  })

  const onSubmit = async (data: SignupMiUser) => {
    setRequestState({ isLoading: true })
    try {
      await postSignupData(data)
    } catch (error) {
      setRequestState({
        isLoading: false,
        errorMessage: `アカウント作成に失敗しました。\n時間を置いて再度お試しください。`,
      })
      return
    }

    const { email, password } = data
    try {
      await setPersistence(auth, browserLocalPersistence)
      await signInWithEmailAndPassword(auth, email, password)
      setRequestState({ isLoading: false })
      location.href = LoginPath
    } catch (error) {
      setRequestState({
        isLoading: false,
        errorMessage: `認証に失敗しました。\n時間を置いて再度お試しください。`,
      })
    }
  }

  if (!(key && email)) {
    location.href = SendEmailPath
    return (
      <>
        <Container className="containerBase"></Container>
      </>
    )
  }

  return (
    <>
      <div className="containerBase">
        <Container>
          <form onSubmit={handleSubmit(onSubmit)} className="miForm">
            <Row>
              <StyleFormHead>
                <img src="/images/miproteger-logo.png" alt="" />
                <p>アカウント登録</p>
              </StyleFormHead>
            </Row>
            <Row>
              <hr className="solid"></hr>
            </Row>

            <Row>
              <Col xs={6} className="inputBox">
                <ErrorMessage
                  errors={errors}
                  name="lastName"
                  render={({ message }) => <HelperText>*{message}</HelperText>}
                />
                <Input
                  placeholder="姓"
                  isError={!!errors.lastName}
                  {...register('lastName', {
                    required: '姓は必須です',
                    maxLength: 100,
                  })}
                />
              </Col>
              <Col xs={6} className="inputBox">
                <ErrorMessage
                  errors={errors}
                  name="firstName"
                  render={({ message }) => <HelperText>*{message}</HelperText>}
                />
                <Input
                  placeholder="名"
                  isError={!!errors.lastName}
                  {...register('firstName', {
                    required: '名は必須です',
                    maxLength: 100,
                  })}
                />
              </Col>
            </Row>
            <Row>
              <Col className="inputBox">
                <ErrorMessage
                  errors={errors}
                  name="password"
                  render={({ message }) => <HelperText>*{message}</HelperText>}
                />
                <Input
                  type="password"
                  placeholder="パスワード（8~16文字）"
                  isError={!!errors.password}
                  {...register('password', {
                    required: 'パスワードは必須です（8~16文字）',
                    pattern: {
                      value: /^[!-~]{8,16}$/,
                      message: '8~16文字で入力してください',
                    },
                  })}
                />
              </Col>
            </Row>
            <Row>
              <Col className="inputBox">
                <ErrorMessage
                  errors={errors}
                  name="passwordConfirmation"
                  render={({ message }) => <HelperText>*{message || 'パスワードが一致していません'}</HelperText>}
                />
                <Input
                  type="password"
                  placeholder="パスワード（確認）"
                  isError={!!errors.passwordConfirmation}
                  {...register('passwordConfirmation', {
                    required: 'パスワード（確認）は必須です',
                    validate: (value) => value === getValues('password'),
                  })}
                />
              </Col>
            </Row>

            <Row>
              <Col className="button">
                <Button
                  buttonType="contained"
                  isSubmit
                  onClick={() => undefined}
                  disabled={!!Object.keys(errors).length}
                  isFullWidth
                >
                  サインアップ
                </Button>
              </Col>
            </Row>
          </form>
        </Container>
      </div>
    </>
  )
}
